const API_ROOT = process.env.REACT_APP_API_ROOT;
const MOUNT_POINT = process.env.REACT_APP_MOUNT_POINT;

const conf = {
	API_ROOT
	,MOUNT_POINT
	,FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL

	,DYMO_LABEL_URL: `/download/ricciardi.label`

	,apis: {
		user: {
			login: API_ROOT + '/AppUsers/login'
			,logout: API_ROOT + '/AppUsers/logout'
			,requestPasswordReset: API_ROOT + '/AppUsers/reset'
			,resetPassword: API_ROOT + '/AppUsers/reset-password'
			,verify: (userId) => `${API_ROOT}/AppUsers/${userId}/verify`
			,current: API_ROOT + '/AppUsers/me'
			,find: API_ROOT + '/AppUsers'
			,create: API_ROOT + '/AppUsers'
			,update: (userId) => `${API_ROOT}/AppUsers/${userId}`
			,findById: (userId) => `${API_ROOT}/AppUsers/${userId}`
			,delete: (userId) => `${API_ROOT}/AppUsers/${userId}`
		}

		,shippingItem: {
			find: API_ROOT + '/ShippingItems'
			,count: API_ROOT + '/ShippingItems/count'
			,create: API_ROOT + '/ShippingItems'
			,update: (id) => `${API_ROOT}/ShippingItems/${id}`
			,findById: (id) => `${API_ROOT}/ShippingItems/${id}`
			,delete: (id) => `${API_ROOT}/ShippingItems/${id}`
			,updateWithWhere: `${API_ROOT}/ShippingItems/update`
			,uploadFile: `${API_ROOT}/ShippingItems/upload`
			,generateDeliveryNotes: `${API_ROOT}/ShippingItems/generateDeliveryNotes`
		}

		,roles: {
			find: API_ROOT + '/Roles'
		}

		,roleMappings: {
			create: API_ROOT + '/RoleMappings'
		}
	}
};

export default conf;
